import groq from 'groq'

import { frameBuilderDefaultFrameObjectFragment } from './default-frame'
import {
  frameBuilderGlassObjectFragment,
  frameBuilderProductGlassObjectFragment,
} from './glass'
import {
  frameBuilderPassepartoutColorObjectFragment,
  frameBuilderProductPassepartoutColorObjectFragment,
} from './passepartout'
import {
  frameBuilderProductProfileObjectFragment,
  frameBuilderProfileObjectFragment,
} from './profile'
import {
  frameBuilderProductProfileTextureObjectFragment,
  frameBuilderProfileTextureObjectFragment,
} from './profile-texture'
import {
  frameBuilderProductSettingsObjectFragment,
  frameBuilderSettingsObjectFragment,
} from './settings'
import {
  frameBuilderProductServicePricesObjectFragment,
  frameBuilderServicePricesObjectFragment,
} from './service-prices'
import {
  frameBuilderProductSpacerColorObjectFragment,
  frameBuilderProductSpacerSizeObjectFragment,
  frameBuilderSpacerColorObjectFragment,
  frameBuilderSpacerSizeObjectFragment,
} from './spacer'
import {
  frameBuilderProductStandardSizeObjectFragment,
  frameBuilderStandardSizeObjectFragment,
} from './standard-size'
import {
  frameBuilderStringsFragment,
  frameBuilderStringsObjectFragment,
} from './strings'
import {
  frameBuilderProductTextureObjectFragment,
  frameBuilderTextureObjectFragment,
} from './texture'

const frameBuilderConfigurationFragment = groq`
  ${frameBuilderSettingsObjectFragment}
  ${frameBuilderStringsObjectFragment}
  ${frameBuilderDefaultFrameObjectFragment}
  ${frameBuilderServicePricesObjectFragment}
  ${frameBuilderProfileObjectFragment}
  ${frameBuilderTextureObjectFragment}
  ${frameBuilderProfileTextureObjectFragment}
  ${frameBuilderPassepartoutColorObjectFragment}
  ${frameBuilderGlassObjectFragment}
  ${frameBuilderSpacerSizeObjectFragment}
  ${frameBuilderSpacerColorObjectFragment}
  ${frameBuilderStandardSizeObjectFragment}
`

export const frameBuilderModuleFragment = groq`
  frameBuilderType,
  updateHash,
  showProgressBar,
  openDimensionDetails,
  defaultPassepartoutColor,
  defaultPassepartoutWidth,
  defaultPassepartoutHeight,
  "configuration": {
    ${frameBuilderConfigurationFragment}
  },
`

export const frameBuilderConfigurationQuery = groq`
  {
    ${frameBuilderConfigurationFragment}
  }
`

const frameBuilderProductConfigurationFragment = groq`
  ${frameBuilderProductSettingsObjectFragment}
  ${frameBuilderProductServicePricesObjectFragment}
  ${frameBuilderProductProfileObjectFragment}
  ${frameBuilderProductTextureObjectFragment}
  ${frameBuilderProductProfileTextureObjectFragment}
  ${frameBuilderProductPassepartoutColorObjectFragment}
  ${frameBuilderProductGlassObjectFragment}
  ${frameBuilderProductSpacerSizeObjectFragment}
  ${frameBuilderProductSpacerColorObjectFragment}
  ${frameBuilderProductStandardSizeObjectFragment}
`

export const frameBuilderProductConfigurationQuery = groq`
  {
    ${frameBuilderProductConfigurationFragment}
  }
`

export const frameBuilderStringsQuery = groq`
  *[
    _type == "frameBuilderStrings" &&
    locale == $locale
  ][0] {
    ${frameBuilderStringsFragment}
  }
`
